<template>
	<n-space v-show="state.show"
		vertical>
		<n-space vertical>
			<span>Выделенная ширина: <n-input-number v-model:value="state.crop.width"
				@change="state.cropper.setCropBoxData({ width: $event })"/></span>
			<span>Выделенная высота: <n-input-number v-model:value="state.crop.height"
				@change="state.cropper.setCropBoxData({ height: $event })"/></span>
			<span>Выделенная позиция X: <n-input-number v-model:value="state.crop.x"
				@change="state.cropper.setCropBoxData({ left: $event })"/></span>
			<span>Выделенная позиция Y: <n-input-number v-model:value="state.crop.y"
				@change="state.cropper.setCropBoxData({ top: $event })"/></span>


			<n-space>
				<n-button @click="state.cropper.move(0, 10)">
					<n-icon>
						<ArrowUp />
					</n-icon>
				</n-button>
				<n-button @click="state.cropper.move(0, -10)">
					<n-icon>
						<ArrowDown />
					</n-icon>
				</n-button>
				<n-button @click="state.cropper.move(10, 0)">
					<n-icon>
						<ArrowBack />
					</n-icon>
				</n-button>
				<n-button @click="state.cropper.move(-10, 0)">
					<n-icon>
						<ArrowForward />
					</n-icon>
				</n-button>
			</n-space>
			<span style="font-size: 12px">(Для сохранения изображения нажмите кнопку <b>сохранить</b>)</span>
		</n-space>
		<img id="img-cropper"
			:src="state.image"
			alt="">
		<n-space style="margin-top: 20px;">
			<n-button @click="cropperClear">Сброс</n-button>
			<n-button :disabled="state.loading"
				@click="cropperSave">Сохранить</n-button>
		</n-space>
	</n-space>
</template>

<script setup>
import { ArrowUp, ArrowDown, ArrowBack, ArrowForward } from "@vicons/ionicons5"
import "cropperjs/dist/cropper.css"
import Cropper from "cropperjs"
import { reactive, defineProps, defineEmits, onMounted } from "vue"
import axios from "axios"
import { useMessage } from "naive-ui"

const message = useMessage()

const props = defineProps({
	src: {
		type: String,
		default: null
	},
	parent_image: {
		type: String,
		default: null
	},
	url: {
		type: String,
		default: null,
		required: true
	},
	img_attr: {
		type: String,
		default: "img",
	}
})
console.log(props)
const emits = defineEmits([
	"save",
	"error"
])

const state = reactive({
	show: false,
	loading: false,
	image: props.src,
	crop: {
		width: null,
		height: null,
		x: null,
		y: null
	}
})

const cropperClear = () => {
	state.cropper.reset()
}

const cropperSave = async () => {
	state.loading = true
	await state.cropper.getCroppedCanvas().toBlob((b) => {
		cropImage(b)
	}, "image/jpg")
}

const cropImage = async(blob) => {
	const formData = await new FormData()
	formData.append(props.img_attr, blob, blob)

	await axios.request({
		method: "POST",
		url: props.url,
		data: formData,
		headers: { "Content-Type": "multipart/form-data" },
	}).then(response => {

		emits("save", {
			img: response.data.message,
			img_path: response.data.fullpath 
		})
		message.success("Изображение сохранено")
	}).catch((error) => {
		if (error.response.data.message.length !== 0) {
			message.error(error.response.data.message)
		} else {
			message.error("Не удалось подключиться к серверу")
		}
	})
	state.loading = false
}

onMounted(async () => {
	await axios.request({
		method: "GET",
		url: props.src
	})
		.then(() => {
			state.show = true
		})
		.catch(() => {
			emits("error")
			return false
		})
	state.cropper = new Cropper(document.querySelector("#img-cropper"), {
		ready() {
			state.cropper.setCropBoxData({
				left: 0,
				top: 0,
				width: 100,
				height: 100 
			})
			state.crop.width = state.cropper.getCropBoxData().width
			state.crop.height = state.cropper.getCropBoxData().height
			state.crop.x = state.cropper.getCropBoxData().left
			state.crop.y = state.cropper.getCropBoxData().top
		},
		crop(e) {
			state.crop.width = Math.round(e.detail.width)
			state.crop.height = Math.round(e.detail.height)
			state.crop.x = Math.round(e.detail.x)
			state.crop.y = Math.round(e.detail.y)
		}
	})
})

</script>

<style>
  #img-cropper {
    width: 100%;
  }
</style>